import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createInvestmentCompanyTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  const hasUid = (row: any) => !!row && !!row.uid;

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowAction.Edit) },
      { label: 'Pagos', icon: 'payment', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowAction.Pay) },
      { label: 'Contabilizar (asiento libre)', icon: 'show_chart', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowAction.Contabilizar) },
      { label: 'Descargar documento (imagen)', icon: 'image', visible: (row) => hasUid(row) && row.isImage === true, callback: (row) => handleAction(row, TableRowAction.DownloadImage) },
      { label: 'Descargar documento (PDF)', icon: 'attach_file', visible: (row) => hasUid(row) && row.isPdf === true, callback: (row) => handleAction(row, TableRowAction.DownloadPdf) },
      { label: 'Eliminar', icon: 'delete', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    headerActions: headerActions,
    gridActions: gridActions,
    filterView: options.filterView || 'investmentCompany',
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  DownloadImage = 'downloadImage',
  DownloadPdf = 'downloadPdf',
  Pay = 'pay',
  Contabilizar = 'contabilizar',
}
